module.exports = __webpack_public_path__ + "images/photoshoot1-02155b93942f59ae897ba5a935579bc9.jpg";